var render = function render(){var _vm=this,_c=_vm._self._c;return _c('member-list',{attrs:{"gender":"female","title-key":"memberList.femaleTitle"}})
}
var staticRenderFns = []

export { render, staticRenderFns }